export const SERVER_URL = process.env.REACT_APP_API_URL_NEW
// export const SERVER_URL = "http://localhost:9501"
